import React, { useEffect } from "react";
import { useState } from "react";
import { RadioGroup } from "@headlessui/react";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

interface NetworkSelectorProps {
  // eslint-disable-next-line no-unused-vars
  onChange: (value: any) => void;
  networks: string[];
  defaultValue?: any;
}

export default function NetworkSelector({ defaultValue = null, onChange, networks }: NetworkSelectorProps) {
  const [selected, setSelected] = useState(defaultValue);
  const filteredNetworks = [
    // [
    //   0,
    //   "BTC Mainnet",
    //   "bitcoin"
    // ],
    [
      1,
      "Ethereum",
      "ethereum"
    ],
    [
      56,
      "Binance Smart Chain",
      "binance"
    ],
  ].filter(
    // @ts-ignore
    (network) => networks.includes(network[2])
  );

  useEffect(() => {
    onChange(selected);
  }, [selected]);

  if (filteredNetworks.length === 0) {
    return null;
  }

  return (
    <RadioGroup value={selected} onChange={setSelected}>
      <div className="space-y-4">
        {filteredNetworks.map((network) => (
          <RadioGroup.Option
            key={network[1]}
            value={network}
            className={({ checked, active }) =>
              classNames(
                active || checked || (selected && selected[0] === network[0]) ? "bg-[#FED700]" : "bg-white",
                "relative block cursor-pointer rounded-full p-3 shadow-sm focus:outline-none justify-between"
              )
            }
          >
            {({ active, checked }) => (
              <>
                <span
                  className={classNames(
                    active || checked ? "" : "",
                    "text-black flex flex-col text-sm text-center w-full")}
                >
                  <RadioGroup.Label as="span" className="font-bold">
                    {network[1]}
                  </RadioGroup.Label>
                </span>
              </>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  );
}
